import React, { useEffect, useRef } from "react";

interface Props {
  index: number;
  curr: number;
  src: string;
  nextSlide: any;
  loop?: boolean;
}

const VideoSlide: React.FC<Props> = ({ index, curr, src, nextSlide, loop }) => {
  const video = useRef<HTMLVideoElement>(null);

  const play = () => {
    if (video.current) {
      video.current.play();
    }
  };
  const reset = () => {
    if (video.current) {
      video.current.pause();
      video.current.currentTime = 0;
    }
  };
  useEffect(() => {
    if (curr === index) {
      play();
    } else {
      reset();
    }
  }, [curr]);
  return (
    <div className="video">
      <video ref={video} muted={true} onEnded={(e) => nextSlide()} loop={loop}>
        <source src={src} type="video/mp4" />
      </video>
    </div>
  );
};

export default VideoSlide;
